import { baseApiWithCompanyId } from 'src/redux/services/baseApi';
import { ScheduleExportPayload, Export } from 'src/dto/Export';

export interface GetExportsResponse {
  items: Export[];
  documents: Export[];
  total: number;
  filters: {
    company_id: string;
  };
}

const exportsApi = baseApiWithCompanyId.injectEndpoints({
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getExports: builder.query<GetExportsResponse, void>({
      query: () => ({
        url: 'v2/exports',
      }),
      providesTags: ['Exports'],
    }),

    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    getAnalyticsExports: builder.query<GetExportsResponse, void>({
      query: () => ({
        url: '/v1/customer-report/list',
      }),
      providesTags: ['Analytics'],
    }),
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    scheduleExport: builder.mutation<{ status: 'ok' }, ScheduleExportPayload>({
      query(data) {
        return {
          url: `v2/exports/schedule`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['Exports'],
    }),
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    scheduleAnalytics: builder.mutation<{ status: 'ok' }, ScheduleExportPayload>({
      query(data) {
        return {
          url: `/v1/customer-report/generate`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['Analytics'],
    }),
  }),
});

export const { useGetExportsQuery, useGetAnalyticsExportsQuery, useScheduleExportMutation, useScheduleAnalyticsMutation } = exportsApi;
